import './ims_tab_count.scss';
import angular from 'angular';

export const uibTabDirectiveDecorator = ($provide, angular) => {
    'ngInject';
    $provide.decorator('uibTabDirective', function ($delegate) {
        'ngInject';
        let directive = $delegate[0];
        // Add the count parameter to the scope
        angular.extend(directive.scope, {
            count: '=',
        });
        return $delegate;
    });
};

export const uibTabWithCountDirective = (uibTabDirective) => {
    'ngInject';
    return angular.extend({}, uibTabDirective[0], {
        // This template can make use of the newly added count parameter. Apart from that addition
        // it is the same as the original template
        templateUrl: 'ims_tab_with_count.html',
        scope: {
            count: '=',
        },
    });
};
